import { useMutation, useQueryClient } from "@tanstack/react-query";
import { UpdateAbsenceDto } from "@myapp/contract";
import { rescheduleKeys } from "src/entities/reschedule";
import { appointmentKeys } from "src/entities/appointment/api/appointment.keys";
import { taskKeys } from "src/entities/task/api/task.keys";
import { scheduleKeys } from "src/entities/schedule/api/schedule.keys";
import { absenceApi } from "../service";
import { absenceKeys } from "../absence.keys";

/**
 * Same reach as `useCreateAbsence`, in both directions: moving an absence onto new blocks flags
 * them, and moving it off the old ones lets `RescheduleFlagSweeper` clear those.
 */
export function useUpdateAbsence() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, dto }: { id: number; dto: UpdateAbsenceDto }) =>
      absenceApi.update(id, dto).then((r) => r.data),
    onSuccess: (_data, { id }) => {
      queryClient.invalidateQueries({ queryKey: absenceKeys.detail(id) });
      queryClient.invalidateQueries({ queryKey: absenceKeys.lists() });
      queryClient.invalidateQueries({ queryKey: rescheduleKeys.all });
      queryClient.invalidateQueries({ queryKey: scheduleKeys.all });
      queryClient.invalidateQueries({ queryKey: appointmentKeys.all });
      queryClient.invalidateQueries({ queryKey: taskKeys.all });
    },
  });
}
